export default __webpack_public_path__ + "static/media/warning_icon.a389b387.svg";